import { PlayingState } from 'components/discover/video/playingState';
import { createContext, useContext } from 'react';

export type PlayVideo = (videoId: string, name?: string) => void;
export const PlayVideoContext = createContext<PlayingState | null>(null);

export function usePlayVideoState() {
  return useContext(PlayVideoContext);
}
